import React, { useState } from 'react';
import { NeoModal, NeoButton, NeoInput, NeoAlert } from '../../../../components/Common';

const CloseCashierModal = ({ isOpen, toggle, onConfirm, isProcessing }) => {
    const [closingBalance, setClosingBalance] = useState(0);

    const handleConfirm = () => {
        onConfirm({ closingBalance: Number(closingBalance) });
    };

    // Reseta ao abrir
    React.useEffect(() => {
        if (isOpen) {
            setClosingBalance(0);
        }
    }, [isOpen]);

    return (
        <NeoModal
            isOpen={isOpen}
            toggle={toggle}
            title="Fechamento Cego de Caixa"
            subtitle="Encerre o turno de trabalho atual"
            headerIcon="mdi-lock-outline"
            footerActions={
                <>
                    <NeoButton 
                        variant="secondary"
                        onClick={toggle} 
                        disabled={isProcessing}
                    >
                        Revisar
                    </NeoButton>
                    <NeoButton 
                        variant="danger" 
                        onClick={handleConfirm}
                        disabled={isProcessing} 
                        loading={isProcessing}
                        icon="mdi-lock"
                    >
                        Confirmar Fecho
                    </NeoButton>
                </>
            }
        >
            <NeoAlert color="warning" title="Atenção!">
                Conte as cédulas e moedas da sua gaveta com cuidado. O sistema calculará automaticamente as possíveis sobras ou quebras baseando-se nos lançamentos recebidos em dinheiro durante o seu turno.
            </NeoAlert>

            <div className="mb-0 text-center">
                <label 
                    className="font-size-11 text-muted fw-bold mb-3 d-block text-uppercase"
                    style={{ letterSpacing: "0.5px" }}
                >
                    A CONTAGEM DA GAVETA
                </label>
                <NeoInput
                    id="closing-balance-input"
                    name="closingBalance"
                    type="number"
                    placeholder="0,00"
                    min="0"
                    step="0.01"
                    value={closingBalance}
                    onChange={(e) => setClosingBalance(e.target.value || 0)}
                    autoComplete="off"
                    size="md"
                    inputStyle={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem' }}
                />
                <small className="text-muted d-block mt-3 px-4 font-size-11" style={{ lineHeight: "1.4" }}>
                    Informe apenas o <b>valor total físico</b> (em espécie) contido no caixa agora. Pagamentos eletrônicos (PIX, Cartão) são apurados automaticamente.
                </small>
            </div>
        </NeoModal>
    );
};

export default CloseCashierModal;
